const selectCategory = document.querySelector('.category');
const selectFileType = document.querySelector('.filetype'); 
const input = document.querySelector('.input_field');

selectCategory.addEventListener('change', filterItems);
selectFileType.addEventListener('change', filterItems);
input.addEventListener('input', filterItems);

function getCategory() {
    return selectCategory.value; 
}

function getFileType() {
    return selectFileType.value; 
}

function filterItems() {
    const filterText = input.value.trim().toLowerCase(); 
    const selectedCategory = getCategory();
    const selectedFileType = getFileType();
    const items = document.querySelectorAll('.download'); 

    items.forEach(item => {
        const title = item.getAttribute('data-title').toLowerCase();
        const category = item.getAttribute('data-category');
        const filetype = item.getAttribute('data-filetype');

        const matchesTitle = filterText.length === 0 || title.includes(filterText); 
        const matchesCategory = selectedCategory === '*' || category === selectedCategory;
        const matchesFileType = selectedFileType === '*' || filetype === selectedFileType; 

        if (
            (matchesTitle && matchesCategory && matchesFileType) || 
            (filterText.length === 0 && selectedCategory === '*' && selectedFileType === '*') 
        ) {
            item.style.display = '';
        } else {
            item.style.display = 'none'; 
        }
    });
}
